import styled from 'styled-components';
import tw, { classnames, textColor, fontSize, letterSpacing, padding, fontWeight, lineHeight } from 'tailwindcss-classnames'

export const HeaderTitle = styled.h1.attrs({
    className: classnames(textColor('text-gpas-700' as any), fontSize('text-5xl', 'sm:text-4xl', 'md:text-5xl', 'xl:text-5xl'), letterSpacing('tracking-tight'), padding('xl:pt-20'), fontWeight('font-medium'), lineHeight('leading-tight'))
})``;
